import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

export const poItemAdd = createAsyncThunk("poItemAdd", async (values, { rejectWithValue }) => {
	try {
		const {channel,po_id,data}  = values
		const response = await axiosHttp.post(`${REWARD_BASE_URL}channel/${channel}/po/${po_id}/item`, { ...data});
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const RewardsPOItemAddSlice = createSlice({
	name: "RewardsPOItemAddSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPOItemAddState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(poItemAdd.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(poItemAdd.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(poItemAdd.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPOItemAddState } = RewardsPOItemAddSlice.actions;
export default RewardsPOItemAddSlice.reducer;
